module.exports = __webpack_public_path__ + "img/熟地黄.d8628b92.jpg";